module.exports = __webpack_public_path__ + "static/cp-lines-inverse-44c72cbbe40f58d126191ef99ce353a1.png";